export default __webpack_public_path__ + "static/5-6ee8c51d6e331fd1eb1779bf8de66df3.jpeg";